import { useDispatch, useSelector } from "react-redux"
import { ApplicationState } from "../../interface/ApplicationState"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { setUserBegin, updateLocalUser } from "../../redux/actions/userActions"
import { useEffect, useState } from "react"
import { alpha, useTheme } from "@mui/material/styles"



export const PairSelector = () =>
{
  const theme = useTheme()
  const dispatch = useDispatch()
  const tradingPairs = useSelector((state: ApplicationState) => state.userStore.user.tradingPairs)
  const tradingPair = useSelector((state: ApplicationState) => state.userStore.user.tradingPair)

  const isMultiTradingEnabled = useSelector((state: ApplicationState) => state.userStore.user.isMultiTradingEnabled)
  const [ pairId, setPairId ] = useState("")

  useEffect(() => {

    // Set the first pair on mount  
    if(!pairId) handleMount()

  }, [tradingPairs])

  const handleMount = () =>
  {
    const pair = tradingPairs?.find(p => p.pair === tradingPair)
    if(pair) setPairId(pair.pairId)
  }

  const handleUpdate = (pairId: string) =>
  {
    setPairId(pairId)
    const pair = tradingPairs?.find(p => p.pairId === pairId)
    dispatch(updateLocalUser({ tradingPair: pair?.pair, fundingCurrency: pair?.base, chartInterval: pair?.interval }))
    dispatch(setUserBegin({ tradingPair: pair?.pair, fundingCurrency: pair?.base, chartInterval: pair?.interval }))
  }

  if(isMultiTradingEnabled && tradingPairs && tradingPairs.length)
  {
    return(
      <Select
        size="small"
        sx={styles.select(theme)}
        value={pairId}
        onChange={(e: any) => handleUpdate(e.target.value)}
      >
          {tradingPairs?.map((p, key) => <MenuItem value={p.pairId} key={key}>{p.pair}</MenuItem>)}
      </Select>
    )
  }

  return (<></>)
}

const styles = {
  select: (theme: any) => ({
    mr: 2,
    minWidth: 120,
    color: theme.palette.text.primary,
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.04 : 0.72),
    borderRadius: "16px",
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.42),
    },
    '& .MuiSelect-icon': {
      color: alpha(theme.palette.text.primary, 0.72),
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.5 : 0.55),
    },
  }),
}
